import type { ToastMessageOptions } from 'primevue/toast';
import { useToast } from 'primevue/usetoast';

export type DsToastOptions = Omit<ToastMessageOptions, 'life' | 'closable' | 'severity'> & {
    severity?: 'info' | 'error';
    /** When true, the toast stays visible until the user dismisses it. */
    persistent?: boolean;
};

const TOAST_LIFETIME_MS = 8 * 1000; // 8 seconds

/** Exposes preset configurations for the PrimeVue Toast component wrapped via DsToast */
export const useDsToast = (group = 'ds-toast') => {
    const { add: pvAdd, remove: removeToast } = useToast();

    const addToast = ({ persistent, ...options }: DsToastOptions) => {
        return pvAdd({
            severity: 'info',
            ...options,
            ...(!persistent && { life: TOAST_LIFETIME_MS }),
            closable: true,
            group,
        });
    };

    return {
        addToast,
        removeToast,
    };
};

export default useDsToast;
